import React, { useEffect, useState, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { videoService } from '../services/api';

const VimeoCallback = () => {
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [errorMessage, setErrorMessage] = useState('');
  const hasProcessed = useRef(false);

  useEffect(() => {
    const handleCallback = async () => {
      if (hasProcessed.current) {
        console.log('[Vimeo Callback] Ya procesado, ignorando');
        return;
      }
      hasProcessed.current = true;

      const isPopup = window.opener && window.opener !== window;
      console.log('[Vimeo Callback] ===== INICIO CALLBACK =====');
      console.log('[Vimeo Callback] isPopup:', isPopup);
      console.log('[Vimeo Callback] window.opener:', window.opener);
      console.log('[Vimeo Callback] URL completa:', window.location.href);

      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const error = urlParams.get('error');

        console.log('[Vimeo Callback] Parámetros recibidos:', { 
          code: code ? code.substring(0, 20) + '...' : 'NO CODE', 
          state, 
          error 
        });

        if (error) {
          console.error('[Vimeo Callback] Error en callback:', error);
          setStatus('error');
          setErrorMessage(error);
          
          if (isPopup) {
            window.opener.postMessage({
              type: 'vimeo_auth_error',
              error: error
            }, window.location.origin);
            
            setTimeout(() => window.close(), 1500);
          }
          return;
        }

        if (!code) {
          console.error('[Vimeo Callback] No se recibió código');
          setStatus('error');
          setErrorMessage('No se recibió código de autorización');
          
          if (isPopup) {
            window.opener.postMessage({
              type: 'vimeo_auth_error',
              error: 'No se recibió código de autorización'
            }, window.location.origin);
            
            setTimeout(() => window.close(), 1500);
          }
          return;
        }

        // Verificar el state
        const savedState = sessionStorage.getItem('vimeo_oauth_state');
        console.log('[Vimeo Callback] Verificando state:', { received: state, saved: savedState });
        
        if (state !== savedState) {
          console.error('[Vimeo Callback] Estado de OAuth inválido');
          setStatus('error');
          setErrorMessage('Estado de OAuth inválido');
          
          if (isPopup) {
            window.opener.postMessage({
              type: 'vimeo_auth_error',
              error: 'Estado de OAuth inválido'
            }, window.location.origin);
            
            setTimeout(() => window.close(), 1500);
          }
          return;
        }

        const redirectUri = sessionStorage.getItem('vimeo_redirect_uri');
        
        console.log('[Vimeo Callback] Intercambiando código por token...');
        setStatus('processing');
        
        // Intercambiar código por token
        const response = await videoService.exchangeVimeoCode(code, redirectUri);

        console.log('[Vimeo Callback] Respuesta del exchange:', response);

        if (response.success) {
          const { accessToken, userInfo } = response.data;
          console.log('[Vimeo Callback] Token obtenido exitosamente');

          setStatus('success');

          // Limpiar sessionStorage
          sessionStorage.removeItem('vimeo_oauth_state');
          sessionStorage.removeItem('vimeo_redirect_uri');

          // Enviar mensaje de éxito al opener
          if (isPopup && window.opener) {
            console.log('[Vimeo Callback] Enviando mensaje de éxito al padre');
            window.opener.postMessage({
              type: 'vimeo_auth_success',
              accessToken: accessToken,
              userInfo: userInfo
            }, window.location.origin);
            
            setTimeout(() => window.close(), 1000);
          }
        } else {
          throw new Error(response.error || 'Error en la autenticación');
        }
      } catch (error) {
        console.error('[Vimeo Callback] Error en callback:', error);
        setStatus('error');
        setErrorMessage(error.message || 'Error procesando callback');
        
        sessionStorage.removeItem('vimeo_oauth_state');
        sessionStorage.removeItem('vimeo_redirect_uri');
        
        if (isPopup) {
          window.opener.postMessage({
            type: 'vimeo_auth_error',
            error: error.message || 'Error procesando callback'
          }, window.location.origin);
          
          setTimeout(() => window.close(), 1500);
        }
      }
    };

    handleCallback();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default'
      }}
    >
      <Box sx={{ textAlign: 'center', maxWidth: 400, p: 4 }}>
        {status === 'processing' && (
          <>
            <CircularProgress size={60} sx={{ mb: 3 }} />
            <Typography variant="h6" gutterBottom>
              Procesando autenticación de Vimeo...
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Por favor espera
            </Typography>
          </>
        )}
        
        {status === 'success' && (
          <>
            <CheckCircleIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom fontWeight="bold">
              ¡Autenticación exitosa!
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Cerrando ventana...
            </Typography>
          </>
        )}
        
        {status === 'error' && (
          <>
            <ErrorIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom fontWeight="bold">
              Error
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {errorMessage}
            </Typography>
            <Typography variant="caption" color="text.disabled">
              Cerrando ventana...
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default VimeoCallback;


